import {createStore} from "effector";

export const $matchesList = createStore({count: 0, data: []})

export const $selectedMatch = createStore({})

export const $approveModalState = createStore({visible: false, id: null, title: '', status: null})

export const $viewMatchModalState = createStore({visible: false, id: null})